export default {
    state: {
        editApplicationModal: false,
        activeApplication: {}
    },

    getters: {
        editApplicationModal: state => state.editApplicationModal,
        activeApplication: state => state.activeApplication,
    },

    mutations: {

        SET_ACTIVE_APPLICATION(state, data)
        {
            state.editApplicationModal = data.value;
            state.activeApplication = data.application;
        }
    }
}
